import { MessageTypes } from '@mortgage-pos/types'
import { redirectTo } from '@mortgage-pos/utils'
import { environment } from '@mortgage-pos/ui/env'

const MINI_FLOW_STORAGE_KEY = 'mini-flow'

/**
 * True when the questionnaire runs inside the BP task drawer. SPA navigations
 * drop the mini-flow query param, so the marker self-persists per browsing
 * context; the iframe check keeps top-level visits out of mini-flow mode.
 */
export function isMiniFlowActive(): boolean {
  if (window.self === window.top) return false

  const fromParam =
    new URLSearchParams(window.location.search).get('mini-flow') === 'true'

  try {
    if (fromParam) {
      window.sessionStorage.setItem(MINI_FLOW_STORAGE_KEY, 'true')
      return true
    }

    return window.sessionStorage.getItem(MINI_FLOW_STORAGE_KEY) === 'true'
  } catch {
    // Storage can be unavailable (privacy modes); fall back to the param.
    return fromParam
  }
}

/** Query fragment that keeps an in-iframe question-set handoff in mini-flow mode. */
export function miniFlowParam(): string {
  return isMiniFlowActive() ? '&mini-flow=true' : ''
}

/**
 * Leave the questionnaire for the borrower portal. Inside the drawer, ask the
 * parent to close it (without completing the task) instead of nesting BP.
 */
export function exitToBorrowerPortal(path = ''): void {
  if (isMiniFlowActive()) {
    window.parent.postMessage(
      {
        name: MessageTypes.MiniFlowExitToPortal,
        payload: { path },
      },
      '*'
    )
    return
  }

  redirectTo(`${environment.borrowerPortal.uiBaseUrl}${path}`)
}
